/* eslint-disable no-param-reassign */
import { ApplicantSettings, ApplicationSettings } from '@common/entities';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetStoreAction } from 'state/commonActions';

export type ApplicationSettingsState = ApplicationSettings;

const initialState: ApplicationSettingsState = {};

const applicationSettingsSlice = createSlice({
  name: 'applicationSettings',
  initialState,
  reducers: {
    setApplicationSettings(state, action: PayloadAction<ApplicationSettingsState>) {
      return { ...state, ...action.payload };
    },
    setPrimarySettings(state, action: PayloadAction<ApplicantSettings>) {
      state.primary = action.payload;
    },
    clearApplicationSettings() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetStoreAction, () => initialState);
  },
});

export const { setApplicationSettings, setPrimarySettings, clearApplicationSettings } =
  applicationSettingsSlice.actions;
export default applicationSettingsSlice.reducer;
